// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"6b766fe3","279":"c62af81f","282":"7ce25355","618":"6b766fe3","709":"09b296ee","767":"bd3ebe9b","819":"6b766fe3","926":"6b766fe3"}[chunkId] + ".chunk.css";
};